import { render, staticRenderFns } from "./FooterHome.vue?vue&type=template&id=834d51d2&scoped=true&"
import script from "./FooterHome.vue?vue&type=script&lang=js&"
export * from "./FooterHome.vue?vue&type=script&lang=js&"
import style0 from "./FooterHome.vue?vue&type=style&index=0&id=834d51d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834d51d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFooter,VRow})
